module.exports = __webpack_public_path__ + "static/media/7.00126441.jpg";